<template>
  <v-toolbar
    v-show="$vuetify.breakpoint.mdAndUp ? fab : md"
    :class="$vuetify.breakpoint.mdAndUp ? 'fixed-bar' : 'fixed-bar2'"
    :height="$vuetify.breakpoint.mdAndUp ? 30 : 48"
    color="primary"
    dense
    flat
    dark
    v-if="dsCaracteristicas.ttinmaecar || 
    Object.entries(EspecifTecnica).length!==0 ||
    Object.entries(Seccion).length!==0 ||
    GetManual()"
  >
    <v-fab-transition v-if="$vuetify.breakpoint.smAndDown">
      <v-btn  fab small absolute bottom right text>
        <pagArt class="mx-auto mt-2 mr-8" :codArt="codArticulo"/>
      </v-btn>
    </v-fab-transition>
    <div class="mx-auto mt-1">
      <v-btn v-scroll="onScroll" class="d-none" fab></v-btn>
      <span
        v-if="dsCaracteristicas.ttinmaecar"
        style="cursor:pointer"
        @click="$vuetify.goTo('#Feature', options)"
        class="font-weight-bold mr-5 white--text"
        ><v-icon class="mt-n1" color="white" size="19">
          mdi-chevron-down
        </v-icon>
        Características</span
      >
      <span
        v-if=" Object.entries(EspecifTecnica).length!==0 && dataUser.IndAutenticado"
        @click="$vuetify.goTo('#Ficha', options)"
        style="cursor:pointer"
        class="font-weight-bold ml-n2 white--text"
      >
        <v-icon class="mt-n1" color="white" size="19">
          mdi-chevron-down
        </v-icon>
        Especificaciones Técnicas
      </span>

      <span
        v-if="Object.entries(Seccion).length!==0"
        @click="$vuetify.goTo('#Repuesto', options)"
        style="cursor:pointer"
        class="font-weight-bold white--text"
      >
        <v-icon class="mt-n1 ml-4" color="white" size="19">
          mdi-chevron-down
        </v-icon>
        Repuestos
      </span>
      <span
        v-if="Object.entries(MaquinaRep).length!==0"
        @click="$vuetify.goTo('#MaquinaRep', options)"
        style="cursor:pointer"
        class="font-weight-bold white--text"
      >
        <v-icon class="mt-n1 ml-4" color="white" size="19">
          mdi-chevron-down
        </v-icon>
        Maquinas
      </span>
      
      <span
        @click="$vuetify.goTo('#Manuals', options)"
        style="color: white; cursor: pointer"
        class="font-weight-bold"
        v-if="GetManual() && false"
      >
        <v-icon class="mt-n1 ml-4" color="white" size="19">
          mdi-chevron-down
        </v-icon>
        Manuales
      </span>
    </div>
  </v-toolbar>
</template>

<script>
import { mapGetters, mapState} from "vuex";
import pagArt from "../components/pagArt";
export default {
  data() {
    return {
      fab: false,
      md: true,
      offset: 35,
      duration: 300,
    };
  },
  created(){
   this.GetManual()
  
  },
  components: {
    pagArt,
  },
  props: {
    despiece: String,
    tipoart: String,
  },

  computed: {
    ...mapGetters(["isManual"]),
    ...mapState([
      "Articulo",
      "dataUser",
      "EspecifTecnica",
      "MaquinaRep",
      "dsCaracteristicas",
      "imgMarcas",
      "imgPeque",
      "Seccion",
      "ttindeslit"
    ]),
     
    options() {
      return {
        duration: this.duration,
        offset: this.offset,
      };
    },

    codigoArt: function() {
      return function(id) {
        if (this.Articulo) {
          var nb = this.Articulo.filter((x) => x.Codigo === id).map(
            (x) => x.Codigo
          );
          return nb.toString();
        }
      };
    },

    codArticulo: {
      get: function() {
        return this.$route.params.codart;
      },
    },
    despieceFile: function() {
      return function(id) {
        if (this.Articulo) {
          return this.Articulo.filter((x) => x.Codigo === id)
            .map((x) => x.Despiece)
            .toString();
        }
      };
    },
    despieceArt: function() {
      return function(id) {
        if (this.Articulo) {
          return this.Articulo.filter((x) => x.Codigo === id)
            .map((x) => x.Despiece)
            .toString();
        }
      };
    },
  },
  methods: {
      GetManual() {
  

    if(this.isManual)
       return this.isManual
   
    },
    onScroll(e) {
      if (typeof window === "undefined") return;
      const top = window.pageYOffset || e.target.scrollTop || 0;
      this.fab = top > 80;
    },
  },
};
</script>

<style scoped>
.fixed-bar {
  position: sticky;
  position: -webkit-sticky; /* for Safari */
  top: 9.5em;
  z-index: 2;
}
.fixed-bar2 {
  position: sticky;
  position: -webkit-sticky; /* for Safari */
  top: 7.5em;
  z-index: 2;
}
.nolink {
  text-decoration: none;
  color: inherit;
}
</style>
